import { Injectable } from '@angular/core';
import { CircleMarker, latLngBounds, LatLngBounds, Polyline } from 'leaflet';
import { BehaviorSubject } from 'rxjs';
import { DuctMapping } from '../../../span-progress-entities';

export type InteractionType = 'mapInteraction' | 'ductListInteraction';
export interface SelectedDuctInformation {
  interaction: InteractionType;
  duct: DuctMapping | null;
}
@Injectable({
  providedIn: 'root',
})
export class DuctInteractionService {
  selectedDuct$ = new BehaviorSubject<SelectedDuctInformation>({
    duct: null,
    interaction: 'ductListInteraction',
  });
  searchValue$ = new BehaviorSubject<string>('');

  getSelectedDuctValue() {
    return this.selectedDuct$.getValue();
  }

  getSelectedDuct$() {
    return this.selectedDuct$.asObservable();
  }

  setSelectedDuct(selectedDuct: SelectedDuctInformation) {
    this.selectedDuct$.next(selectedDuct);
  }

  setSearchValue(searchValue: string) {
    this.searchValue$.next(searchValue);
  }

  getSearchValue$() {
    return this.searchValue$.asObservable();
  }

  calculateFeatureBounds(mapObjects: (Polyline | CircleMarker)[]) {
    return mapObjects.reduce(
      (acc: LatLngBounds | null, mapObject: Polyline | CircleMarker) => {
        if (
          mapObject.feature?.geometry.type !== 'LineString' &&
          mapObject.feature?.geometry.type !== 'Point'
        ) {
          return acc;
        } else if (mapObject.feature?.geometry.type === 'LineString') {
          return acc
            ? acc.extend((mapObject as Polyline).getBounds())
            : (mapObject as Polyline).getBounds();
        } else if (mapObject.feature?.geometry.type === 'Point') {
          const latLngs = [(mapObject as CircleMarker).getLatLng()];
          const markerBounds = latLngBounds(latLngs);
          return acc ? acc.extend(markerBounds) : markerBounds;
        }
      },
      null,
    );
  }
}
